<template>
  <v-dialog
      :value="showModal"
      persistent
      max-width="750"
  >
    <v-card>
      <v-card-title class="text-h5 darken-3 white--text" style="background-color: rgb(0 48 87);">Payroll Deduction Authorization Form</v-card-title>
      <v-card-text dark class='text-center'>
        <iframe
            id="jotform-dues-iframe"
            :src="`${orgDetails.org_ippd_authorization_path_ext}?firstName=${$store.state.oma_first_name}&lastName=${$store.state.oma_last_name}`"
            width="700"
            scrolling="no"
            style="border: none;min-height:500px;"
        />
      </v-card-text>

    </v-card>
  </v-dialog>
</template>
<script>

export default {
  name: 'JotformLightbox',
  // Emits: 'completed'
  props: {
    required: {
      type: Boolean,
      default: false
    },
    orgDetails: {
      type: Object
    },
    appId: {
      type: String,
    }
  },

  data() {
    return {
      showModal: false,
      scriptsLoaded: false
    };
  },
  computed: {
    formId: function(){
      return this.orgDetails.org_ippd_authorization_path_ext.split('/').at(-1);
    }
  },
  watch: {
    required(isRequired) {
      if (isRequired && !this.completed) {
        this.openModal();
      } else if (!isRequired) {
        this.closeModal();
      }
    }
  },

  mounted() {
    this.loadScript(`https://forms.mymea.org/s/umd/latest/for-form-embed-handler.js`)
        .then(() => {
          this.scriptsLoaded = true;
          this.openModal();
        })
        .catch((err) => {
          console.error('Failed to load JotForm embed handler', err);
          this.$emit('load-error', err);
        });

    window.addEventListener('message', this.handleMessage);
  },

  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage);
    document.removeEventListener('keydown', this.handleEscape, true);
  },

  methods: {
    loadScript(src) {
      return new Promise((resolve, reject) => {
        // Avoid loading twice if user navigates back/forth in a SPA
        if (document.querySelector(`script[src="${src}"]`)) {
          resolve();
          return;
        }
        const script = document.createElement('script');
        script.src = src;
        script.type = 'text/javascript';
        script.onload = resolve;
        script.onerror = () => reject(new Error(`Failed to load ${src}`));
        document.head.appendChild(script);
      });
    },

    openModal() {
      this.showModal = true;
      document.body.style.overflow = 'hidden'; // prevent background scroll

      // Wire up the embed handler once the iframe is actually in the DOM
      this.$nextTick(() => {
        if (window.jotformEmbedHandler) {
          window.jotformEmbedHandler(
              `iframe#jotform-dues-iframe`,
              'https://forms.mymea.org'
          );
        }
      });
    },

    closeModal() {
      this.showModal = false;
      document.removeEventListener('keydown', this.handleEscape, true);
      document.body.style.overflow = '';
    },

    handleEscape(e) {
      if (e.key === 'Escape') {
        // Block escape-to-close until the form is completed
        if (!this.completed) {
          e.stopImmediatePropagation();
          e.preventDefault();
        } else {
          this.closeModal();
        }
      }
    },
    handleMessage(event) {
      // Only accept messages from our iframe, once it exists
      const iframe = document.getElementById('jotform-dues-iframe');
      if (iframe && event.source !== iframe.contentWindow) return;
      const data = event.data;
      const isSubmission =
          (typeof data === 'string' && data.indexOf('submission-completed') !== -1) ||
          (data && data.action === 'submission-completed');

      if (isSubmission) {
        window.location.href = `${this.$store.state.survey_url}&referer=oma&referer_id=${this.appId}`;
        this.$destroy();
      }
    }
  }
};
</script>